export const options = state => state.studiesReducer.module.role.options

export const role = state => state.studiesReducer.module.role.role

export const isLoading = state => state.studiesReducer.module.role.isLoading

export const isSuccess = state => state.studiesReducer.module.role.isSuccess

export const permissions = state => state.studiesReducer.module.role.permissions
